import "@/App.css";
import "leaflet/dist/leaflet.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import PWAInstall from "@/components/PWAInstall";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Sites from "@/pages/Sites";
import SiteDetail from "@/pages/SiteDetail";
import Sources from "@/pages/Sources";
import Discrepancies from "@/pages/Discrepancies";
import Audit from "@/pages/Audit";
import Review from "@/pages/Review";
import Partners from "@/pages/Partners";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return <div className="flex h-screen items-center justify-center text-slate-400 font-mono text-sm">Loading ChargeSure…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <PWAInstall />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/sites" element={<Sites />} />
              <Route path="/sites/:id" element={<SiteDetail />} />
              <Route path="/sources" element={<Sources />} />
              <Route path="/discrepancies" element={<Discrepancies />} />
              <Route path="/review" element={<Review />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/audit" element={<Audit />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
